// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  const overlay = image.parentElement.querySelector('.image-magnify-full-size');
  if (!overlay) return;

  const rect = overlay.getBoundingClientRect();

  // Mouse'un zoom alanındaki gerçek konumu
  let x = event.clientX - rect.left;
  let y = event.clientY - rect.top;

  // Kenarlarda taşmayı engelle
  x = Math.max(0, Math.min(x, rect.width));
  y = Math.max(0, Math.min(y, rect.height));

  // 0 - 100 arasında sabit tut
  const xPercent = (x / rect.width) * 100;
  const yPercent = (y / rect.height) * 100;

  overlay.style.backgroundPosition =
    `${xPercent}% ${yPercent}%`;

  // Görselin ekranda görünen gerçek genişliğini kullan
  overlay.style.backgroundSize =
    `${rect.width * zoomRatio}px auto`;
}

function magnify(image, zoomRatio, event) {
  // Aynı görselde zoom zaten varsa tekrar oluşturma
  if (image.parentElement.querySelector('.image-magnify-full-size')) return;

  const overlay = createOverlay(image);

  // Zoom katmanında mouse hareketi (masaüstü)
  overlay.onmousemove = (event) => {
    moveWithHover(image, event, zoomRatio);
  };

  // Sadece masaüstünde görselden çıkınca kapat
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    overlay.addEventListener('mouseleave', () => {
      overlay.remove();
    });
  }

  moveWithHover(image, event, zoomRatio);
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');

  images.forEach((image) => {
    image.style.cursor = 'zoom-in';

    image.addEventListener('mouseenter', (event) => {
      magnify(image, zoomRatio, event);
    });
  });
}
// MASAÜSTÜ
if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  enableZoomOnHover(2);
}

// MOBİL / DOKUNMATİK
else {
  const images = document.querySelectorAll('.image-magnify-hover');

  images.forEach((image) => {
    let lastTap = 0;
    let initialPinchDistance = null;
    let pinchStartZoom = 1;
    let currentZoom = 1;

    function getOverlay() {
      return image.parentElement.querySelector('.image-magnify-full-size');
    }

    function closeZoom() {
      const overlay = getOverlay();

      if (overlay) {
        overlay.remove();
      }

      currentZoom = 1;
      pinchStartZoom = 1;
      initialPinchDistance = null;
    }

    function getDistance(touches) {
      const dx = touches[0].clientX - touches[1].clientX;
      const dy = touches[0].clientY - touches[1].clientY;

      return Math.sqrt(dx * dx + dy * dy);
    }

    function getCenter(touches) {
      return {
        clientX: (touches[0].clientX + touches[1].clientX) / 2,
        clientY: (touches[0].clientY + touches[1].clientY) / 2
      };
    }

    image.addEventListener('touchstart', (event) => {

      // İKİ PARMAKLA BÜYÜTME/KÜÇÜLTME BAŞLANGICI
      if (event.touches.length === 2) {
        event.preventDefault();

        initialPinchDistance = getDistance(event.touches);
        pinchStartZoom = currentZoom;

        return;
      }

      // Tek parmak
      if (event.touches.length !== 1) return;

      const now = Date.now();
      const touch = event.touches[0];

      // ÇİFT DOKUNMA
      if (now - lastTap < 300) {
        event.preventDefault();

        if (getOverlay()) {
          // Zoom açıksa normale dön
          closeZoom();
        } else {
          // Zoom kapalıysa 2x aç
          currentZoom = 2;

          magnify(image, currentZoom, {
            clientX: touch.clientX,
            clientY: touch.clientY
          });
        }

        lastTap = 0;
        return;
      }

      // İLK DOKUNUŞTA ZOOM YOK
      lastTap = now;

    }, { passive: false });


    image.addEventListener('touchmove', (event) => {

      // İKİ PARMAKLA PINCH ZOOM
      if (event.touches.length === 2) {
        event.preventDefault();

        if (!initialPinchDistance) {
          initialPinchDistance = getDistance(event.touches);
          pinchStartZoom = currentZoom;
        }

        const distance = getDistance(event.touches);

        // Parmakların ne kadar açıldığını hesapla
        const scale = distance / initialPinchDistance;

        let newZoom = pinchStartZoom * scale;

        // 1x - 4x arasında tut
        newZoom = Math.max(1, Math.min(newZoom, 4));

        const center = getCenter(event.touches);

        // 1x seviyesine küçültülürse tam görsele dön
        if (newZoom <= 1.05) {
          closeZoom();
          return;
        }

        currentZoom = newZoom;

        // Zoom henüz oluşturulmadıysa oluştur
        if (!getOverlay()) {
          magnify(image, currentZoom, center);
        }

        moveWithHover(
          image,
          {
            clientX: center.clientX,
            clientY: center.clientY
          },
          currentZoom
        );

        return;
      }


      // ZOOM AÇIKKEN TEK PARMAKLA GEZİN
      if (event.touches.length === 1) {
        const overlay = getOverlay();

        if (!overlay) return;

        event.preventDefault();

        const touch = event.touches[0];

        moveWithHover(
          image,
          {
            clientX: touch.clientX,
            clientY: touch.clientY
          },
          currentZoom
        );
      }

    }, { passive: false });


    image.addEventListener('touchend', (event) => {
      // Parmağı kaldırınca zoom açık kalır
      if (event.touches.length < 2) {
        initialPinchDistance = null;
      }
    });


    image.addEventListener('touchcancel', () => {
      initialPinchDistance = null;
    });

  });
}
